import React, { useState, useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./PetFood.css";

const PetFood = () => {

   const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const playVideo = () => {
      const video = videoRef.current;
  
      if (!video) return;
  
      video.pause();
      video.currentTime = 0;
  
      video.play()
        .then(() => {
          setPlaying(true);
        })
        .catch((err) => {
          console.log("Playback failed:", err);
        });
    };
  
    const handlePause = () => {
      setPlaying(false);
    };
  
    const handleEnded = () => {
      setPlaying(false);
    };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <section className="services-page">

        {/* Banner */}
        <div className="service-banner">
          <div className="overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1>Services</h1>
                <p>Quality nutrition and stylish accessories for your pets</p>
              </div>

              <div className="col-lg-6 text-end">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
                  alt="Pets"
                  className="img-fluid banner-pets"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Service Card */}
        <div className="service-section">
          <div className="container">

            <div className="service-card">
              <div className="row">
                <div className="col-md-5">
                  <div className="service-content">
                    <h1 className="font-bold mb-4">
                      Pet Food & Accessories
                    </h1>
                    <p className="font-semibold">
                      Quality nutrition and stylish accessories for your pets. We offer a curated selection of premium pet food, treats, toys, and accessories to keep your pet healthy and happy.
                    </p>
                    <p>
                      From specialized diets to fun toys, our products are carefully chosen to meet the highest standards of quality and safety for your beloved companions.
                    </p>
                    <a className="btn btn-dark rounded-pill px-4 w-mxcontent mt-4 mb-3 font-semibold py-2" href="/ServicesListing">
                      Back to Services
                    </a>
                  </div>
                </div>
                <div className="col-md-7 pe-0">
                  <div className="spe-testimonial-video-wrap mw-100">
  <video
    ref={videoRef}
    className="spe-testimonial-video h-100"
    // poster={`${process.env.PUBLIC_URL}/assets/imgs/video_poster.jpg`}
    controls={playing}
    onPlay={() => setPlaying(true)}
    onPause={() => setPlaying(false)}
    onEnded={() => setPlaying(false)}
  >
    <source
      src={`${process.env.PUBLIC_URL}/assets/video/petfood.mp4`}
      type="video/mp4"
    />
  </video>

  {!playing && (
    <>
      <div className="spe-testimonial-video-overlay"></div>

      <div
        className="spe-testimonial-play-btn"
        onClick={playVideo}
      >
        <i className="fas fa-play"></i>
      </div>
    </>
  )}
</div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </section>
    </>
  );
};

export default PetFood;
